import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateReanudacionCATA = () => {
  const [loadingCreateReanudacionCATA, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateReanudacionCATA, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateReanudacionCATA, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateReanudacionCATA, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createReanudacionCATA = async (userId:string , data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudReanudacion(userId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createReanudacionCATA,
    loadingCreateReanudacionCATA,
    successCreateReanudacionCATA,
    errorCreateReanudacionCATA,
    dataCreateReanudacionCATA
  }

}

export default useCreateReanudacionCATA;
